import React from 'react';
import PhoneButton from '../components/PhoneButton';
import HeroSection from '../components/HeroSection';
import HeroSectionText from '../components/HeroSectionText';
import ServicesSection from '../components/ServicesSection';
import Carousel from '../components/Carousel';

const Home = () => {
  const bathroomImages = [
    { src: '/media/billeder/Badeværelse/IMG_3373.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_2976.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_0089.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_0092.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_0093.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_0096.jpeg', title: 'Badeværelse' },
    { src: '/media/billeder/Badeværelse/IMG_0284.jpeg', title: 'Badeværelse' },
  ];

  const tileImages = [
    { src: '/media/billeder/Fliser/IMG_0047.jpeg', title: 'Fliser' },
    { src: '/media/billeder/Fliser/IMG_0049.jpeg', title: 'Fliser' },
    { src: '/media/billeder/Fliser/IMG_0054.jpeg', title: 'Fliser' },
    { src: '/media/billeder/Fliser/IMG_2281.jpeg', title: 'Fliser' },
  ];

  return (
    <div className="pt-1">
      {/* Hero Section */}
      <HeroSection />

      {/* Carousel Section */}
<section
  style={{
    backgroundImage: "url('/media/back/back1.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
  className="relative py-8 md:py-16"
>
  {/* Light overlay */}
  <div className="absolute inset-0 bg-white/20 pointer-events-none"></div>

  <div className="relative max-w-5xl mx-auto px-4">
    <Carousel bathroomImages={bathroomImages} tileImages={tileImages} />
  </div>
</section>

       <HeroSectionText />
       
      {/* Phone Button */}
      <PhoneButton />
    </div>
  );
};

export default Home;